import { post, download } from '@/utils/examMan/request'

export function updateData(data) {
  return post('/api/learn/api/sys/user/update', data)
}

export function saveData(data) {
  return post('/api/learn/api/sys/user/save', data)
}

export function userReg(data) {
  return post('/api/learn/api/sys/user/reg', data)
}

export function updatePass(data) {
  return post('/api/learn/api/sys/user/update-pass', data)
}

export function findInfo(token) {
  return post('/api/learn/api/sys/user/info', { token: token })
}

export function fetchDetail(id) {
  return post('/api/learn/api/sys/user/detail', { id: id })
}

/**
 * 搜索用户列表
 * @param data
 * @returns {*}
 */
export function fetchPaging(data) {
  return post('/api/learn/api/sys/user/paging', data)
}

/**
 * 导出
 * @param data
 */
export function exportExcel(data) {
  return download('/api/learn/api/sys/user/export', data, '导出的用户.xlsx')
}

/**
 * 批量修改部门
 * @param data
 * @returns {Promise}
 */
export function apiBatchDept(data) {
  return post('/api/learn/api/sys/user/batch-dept', data)
}

/**
 * 批量修改角色
 * @param data
 * @returns {Promise}
 */
export function apiBatchRole(data) {
  return post('/api/learn/api/sys/user/batch-role', data)
}

export function login(data) {
  return post('/api/learn/api/sys/user/login', data)
}

export function getInfo(token) {
  return post('/api/learn/api/sys/user/info', { token: token })
}

export function logout() {
  return post('/api/learn/api/sys/user/logout', {})
}

export function reg(data) {
  return post('/api/learn/api/sys/user/reg', data)
}

export function mobileLogin(data) {
  return post('/api/learn/api/sys/user/mobile-login', data)
}

export function faceLogin(data) {
  return post('/api/sys/user/face-login', data)
}

export function resetPass(data) {
  return post('/api/learn/api/sys/user/reset-pass', data)
}

export function faceCheck(data) {
  return post('/api/learn/api/sys/user/face-check', data)
}

/**
 * 批量修改到期时间
 * @param data
 * @returns {Promise}
 */
export function apiBatchExpire(data) {
  return post('/api/learn/api/sys/user/batch-expire', data)
}
